import {
  GET_ITEMS_AND_PRODUCTS,
  GET_ITEMS_AND_PRODUCTS_ERROR,
  GET_ITEMS_AND_PRODUCTS_SUCCESS
} from './ItemsAndProductsSection.actions'

const itemsAndProductsSectionState = {
  category: null,
  csv: [],
  data: [],
  error: null,
  family: null,
  loading: false,
  type: 'segments'
}

/**
 * The regional items and products section's reducer.
 */
const itemsAndProductsSectionReducer = (state = itemsAndProductsSectionState, { payload, type }) => {
  switch (type) {
    case GET_ITEMS_AND_PRODUCTS: {
      return { ...state, data: [], loading: true }
    }
    case GET_ITEMS_AND_PRODUCTS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_ITEMS_AND_PRODUCTS_SUCCESS: {
      return { ...state, ...payload, loading: false }
    }
    default: {
      return state
    }
  }
}

export default itemsAndProductsSectionReducer
